import React from 'react'

import { Button, Panel, Grid, Row, Col } from 'react-bootstrap'

import { FieldGroup } from './FieldGroup'

import cn from 'classnames'

export const ResetPasswordForm = ({ title, onSubmit, onChange, validateForm, newPassword, confirmPassword, complexityList, children }) => (
  <Grid className="currentStep">
    <Row>
      <div className="AuthContainerForm">
        <h1>{title}</h1>

        {children}
        <Col md={6} xs={12} className="auth-grid-column">
          <form onSubmit={onSubmit} >
            <FieldGroup id="newPassword" label="New Password" type="password" value={newPassword} onChange={onChange} autoFocus />
            <FieldGroup id="confirmPassword" label="Confirm Password" type="password" value={confirmPassword} onChange={onChange} />
            <Row>
              <Col xs={6} xsOffset={4}>
                <Button id="reset-password-button" className="btn btn-default" type="submit" disabled={!validateForm()}>
                  Set Password
                </Button>
              </Col>
            </Row>
          </form>
        </Col>
        <Col md={6} xs={12} className="auth-grid-column">
          <div className="requirements pt-x2">
            <Panel>
              <Panel.Heading>
                <Panel.Title componentClass="h3">Must Contain</Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <ul>{complexityList().map(({ valid, message }) => (<li key={`${valid}-${btoa(message)}`} className={cn({ 'valid': valid, invalid: !valid })}>{message}</li>))}</ul>
              </Panel.Body>
            </Panel>
          </div>
        </Col>
      </div>
    </Row>
  </Grid>
)
